import React, { useState, useEffect, useCallback } from 'react';
import style from 'styles/widgets/DebugPlayer.scss';
import cssModule from 'react-css-modules';
import lcrRequest from 'lcrRequest';
import {
  getIsOperator,
  getLcrStreamUrl,
  getReadyMatchId,
  getUserId,
  getIsStreamAvailable,
} from 'reducers';
import { useSelector } from 'react-redux';
import { parseDebugPlayerUrl } from '../../utils/helpers';
import { buildQueryString } from '../../utils/Url';

const DebugPlayer = () => {
  const userId = useSelector(getUserId);
  const isOperator = useSelector(getIsOperator);
  const streamBaseUrl = useSelector(getLcrStreamUrl);
  const matchId = useSelector(getReadyMatchId);
  const isStreamAvailable = useSelector(getIsStreamAvailable);
  const [finalUrl, setFinalUrl] = useState('');

  const fetchDebugUrl = useCallback(async () => {
    if (!streamBaseUrl || !matchId) {
      setFinalUrl('');
      return;
    }
    try {
      const options = {
        match_id: matchId,
        user_id: isOperator ? userId : null,
      };
      const paramStr = buildQueryString(options);
      const url = `${streamBaseUrl}${paramStr}`;
      const response = await lcrRequest.get(url, { credentials: 'include' });
      if (response && response.url) {
        const debugUrl = parseDebugPlayerUrl(response);
        setFinalUrl(debugUrl);
      } else {
        setFinalUrl('');
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error fetching debug URL:', err);
      setFinalUrl('');
    }
  }, [streamBaseUrl, matchId, isOperator, userId]);

  useEffect(() => {
    fetchDebugUrl();
  }, [fetchDebugUrl]);

  const handleClick = async e => {
    e.preventDefault();
    await fetchDebugUrl();
    if (finalUrl) {
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div styleName='debugPlayerContainer'>
      <button
        type='button'
        styleName='debugPlayerLabel'
        onClick={handleClick}
        disabled={!isStreamAvailable}
      >
        {finalUrl ? 'Launch debug player' : 'Debug stream not available.'}
      </button>
    </div>
  );
};

export default cssModule(DebugPlayer, style);
